class ApiService {
  constructor(apiConfig) {
    this.apiConfig = apiConfig;
  }

  get getLoginUrl() {
    return this.apiConfig.API_URL_LOGIN;
  }

  get getMeUrl() {
    return this.apiConfig.API_GET_ME;
  }

  get getForgotPasswordUrl() {
    return this.apiConfig.API_FORGOT_PASSWORD;
  }
  get getResetPasswordUrl() {
    return this.apiConfig.API_RESET_PASSWORD;
  }

  get getWeatherForecastUrl() {
    return this.apiConfig.API_WEATHER_FORECAST;
  }
  get getWeatherApiKey() {
    return this.apiConfig.weatherApiKey;
  }

  get getWeatherStationDataUrl() {
    return this.apiConfig.API_WEATHER_STATION_DATA;
  }
  get getWatherStationTimeRangeUrl() {
    return this.apiConfig.API_WEATHER_STATION_TIME_RANGE;
  }
}

let apiServiceInstance = null;

const initializeApiService = (apiConfig) => {
  apiServiceInstance = new ApiService(apiConfig);
};

const getApiService = () => {
  if (!apiServiceInstance) {
    throw new Error("ApiService not initialized");
  }
  return apiServiceInstance;
};

export { initializeApiService, getApiService };
